<a>@if (projectImage) {
  <img class="projectImage" [src]="projectImage" >
}</a>
@if (projectData) {
  <a>
    {{projectData[0].description}}
  </a>
}
